import React from 'react';
import { Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import styles from './Header.styles';

export default function Header({ icon, title, description, onBack }) {
  return (
    <div>
      {onBack && (
        <Button onClick={onBack} icon={<LeftOutlined />} style={styles.backButton}>
          Back
        </Button>
      )}
      <div style={styles.headerContainer}>
        <div style={styles.iconContainer}>{icon}</div>
        <div>
          <h2 style={styles.headerTitle}>{title}</h2>
          <p style={styles.headerDescription}>{description}</p>
        </div>
      </div>
    </div>
  );
}
